import { Box, Stack, StackProps, Typography, useTheme } from '@mui/material';

import { VectorImageName } from '~assets/vectors/generated';
import VectorImage from '~components/media/vectorImage';

import Dimens from '../../themes/dimens';

/**
 * Either use iconSize, or specify both iconWidth and iconHeight.
 * When iconSize is set, iconWidth and iconHeight are ignored.
 * When none are set, defaults to a size of 24
 */
interface EmptyStateProps extends StackProps {
	title: string;
	description?: string | undefined;
	icon?: VectorImageName;
	iconTintColor?: string;
	iconSize?: number; // optional square size
	iconWidth?: number;
	iconHeight?: number;
	iconBackdropColor?: string;
	iconBackdropPadding?: string; // Dimens.spacingLg
}

const EmptyState = ({
	title,
	description,
	icon,
	iconTintColor,
	iconSize,
	iconWidth,
	iconHeight,
	iconBackdropColor,
	iconBackdropPadding = Dimens.spacingLg,
	...stackProps
}: EmptyStateProps) => {
	const { palette } = useTheme();

	// Resolve final width and height
	const finalWidth = iconSize ?? iconWidth ?? 24;
	const finalHeight = iconSize ?? iconHeight ?? 24;

	return (
		<Stack sx={{ display: 'flex', alignItems: 'center', ...stackProps.sx }}>
			<Box
				sx={{
					lineHeight: 0, // Need to unset otherwise there's some extra margin on the bottom
					backgroundColor: iconBackdropColor ?? palette.bgTertiary.main,
					padding: iconBackdropPadding,
					borderRadius: Dimens.radiusMd,
					mb: Dimens.spacingLg,
				}}
			>
				<VectorImage
					name={icon ?? 'icon/placeholder'}
					width={finalWidth}
					height={finalHeight}
					color={iconTintColor ?? palette.common.black}
				/>
			</Box>
			<Typography
				variant='label'
				textAlign='center'
				color={palette.textPrimary.main}
				sx={{ mb: Dimens.spacingXs }}
			>
				{title}
			</Typography>
			{description && (
				<Typography variant='paragraphSm' textAlign='center' color={palette.textQuaternary.main}>
					{description}
				</Typography>
			)}
		</Stack>
	);
};

export default EmptyState;
